import { Box, Chip, Collapse, IconButton, TablePagination, Tooltip, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import lineLoader from '../../../../components/lineLoader/lineLoader';
import {
  CustomAlertAction,
  CustomAlertState,
} from '../../../../alert/controller/custom.alert.controller';
import { CustomAlertType } from '../../../../alert/data/custom.alert.type';
import { CustomAlertIcons } from '../../../../alert/data/custom.alert.icon';
import {
  PermissionControllerAction,
  PermissionControllerState,
} from '../../controller/permission.controller';
import { PermissionModel } from '../../model/permission.model';

const defaultStyle = { border: '1px solid #1A1A1A20', padding: 5, backgroundColor: '#EEEFF3' };

const TableTitle = [
  { label: 'ລຳດັບ' },
  { label: 'ລະຫັດ' },
  { label: 'ຊື່ສິດທິ' },
  { label: 'Module' },
  { label: 'ຄໍາອະທິບາຍ' },
  { label: 'ສະຖານະ' },
  { label: 'ການຈັດການ' },
];

const PermissionTable = ({
  ctrl,
  alert,
}: {
  ctrl: PermissionControllerState & PermissionControllerAction;
  alert: CustomAlertState & CustomAlertAction;
}) => {
  return (
    <Box sx={{ overflowX: 'auto' }}>
      <Collapse unmountOnExit orientation="vertical" in={ctrl.loading && ctrl.listCount > 0}>
        {lineLoader()}
      </Collapse>
      <Collapse unmountOnExit orientation="vertical" in={!ctrl.loading || ctrl.listCount > 0}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {TableTitle.map((col, index) => (
                <th key={index} style={{ ...defaultStyle, backgroundColor: '#E4E8F3' }}>
                  <Typography>{col.label}</Typography>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ctrl.list.map((item: PermissionModel, index: number) => (
              <tr key={item.uuid}>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{index + 1 + ctrl.page * ctrl.pageRowAmount}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography fontFamily="monospace" fontSize="13px">
                    {item.code}
                  </Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{item.name}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{item.module || '-'}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center', textWrap: 'wrap' }}>
                  <Typography>{item.description || '-'}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Chip
                    size="small"
                    label={item.is_active ? 'ໃຊ້ງານ' : 'ປິດໃຊ້ງານ'}
                    sx={{
                      backgroundColor: item.is_active ? '#DFF3E4' : '#F3DFDF',
                      color: item.is_active ? '#1F7A3D' : '#A13232',
                    }}
                  />
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Tooltip title={item.is_active ? 'ປິດໃຊ້ງານ' : 'ເປີດໃຊ້ງານ'} placement="top">
                    <IconButton disabled={ctrl.loading} onClick={() => ctrl.onToggleActive(item)}>
                      {item.is_active ? <ToggleOnIcon color="primary" /> : <ToggleOffIcon />}
                    </IconButton>
                  </Tooltip>
                  <IconButton
                    onClick={() => {
                      ctrl.onUpdateFormUpdate({
                        uuid: item.uuid,
                        code: item.code,
                        name: item.name,
                        module: item.module,
                        description: item.description ?? '',
                        is_active: item.is_active,
                      });
                      ctrl.onHandleModal({ name: 'UPDATE' });
                    }}
                  >
                    <BorderColorIcon />
                  </IconButton>
                  <IconButton
                    onClick={() =>
                      alert.handleCustomAlert({
                        title: 'ລົບສິດທິ',
                        important: item.code,
                        message:
                          'ການລົບຈະຖອນສິດທິນີ້ອອກຈາກທຸກບົດບາດທີ່ນຳໃຊ້ຢູ່. ທ່ານຕ້ອງການລົບແທ້ບໍ ?',
                        type: CustomAlertType.WARNING,
                        icon: CustomAlertIcons.deleteConfirm,
                        negText: 'ກັບຄືນ',
                        posText: 'ຢືນຢັນ',
                        onPositive: () => {
                          ctrl.onDelete(item.uuid);
                          alert.handleCustomAlert(null);
                        },
                      })
                    }
                  >
                    <DeleteIcon />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Collapse>

      <Box
        sx={{ display: 'flex', flexDirection: 'row', paddingRight: '20px', alignItems: 'center' }}
      >
        <Typography paddingLeft="20px">ທັງໝົດ {ctrl.listCount} ລາຍການ</Typography>
        <Box sx={{ flex: 1 }} />
        <TablePagination
          component="div"
          colSpan={3}
          rowsPerPageOptions={[10, 25, 50, 100]}
          count={ctrl.listCount}
          page={ctrl.page}
          onPageChange={(_, newPage) => {
            ctrl.onPageChange(newPage, ctrl.pageRowAmount);
            ctrl.onFilterChange({
              ...ctrl.filter,
              skip: ctrl.pageRowAmount * newPage,
              take: ctrl.pageRowAmount,
            });
          }}
          rowsPerPage={ctrl.pageRowAmount ?? 10}
          onRowsPerPageChange={(e) => {
            const rows = Number.parseInt(e.target.value);
            ctrl.onPageChange(0, rows);
            ctrl.onFilterChange({ ...ctrl.filter, skip: 0, take: rows });
          }}
          labelRowsPerPage="ສິດທິຕໍ່ໜ້າ"
        />
      </Box>
    </Box>
  );
};

export default PermissionTable;
